module.exports = __webpack_public_path__ + "static/img/banner.f0f79754.png";